export default {
  featuredExperiences: '精选体验',
  searchAllExperiences: '搜索所有体验',
  searchAll: '搜索全部',
  groupSize: '团体规模',
  eventSize: '活动规模',
  upTo: '最多',
  whatWeDo: '我们将做什么',
  hostedBy: '主办方',
  whatsIncluded: '包含内容',
  avail: '可用性',
  whereWeAre: '地点',
  experienceCalendar: '体验日历',
  experienceCancelled: '体验已取消',
  experienceStartingPrice: '起价 {{price}}',
  experienceTotalPrice: '总计 {{price}}',
  at: '在',
  viewPrivateSessAvailability: '查看私人课程可用性',
  selectSession: '选择课程',
  noAvailability: '无可用时段',
  select: '选择',
  slotsLeft: '剩余 {{remainSlots}} 个名额',
  slotLeft: '剩余 {{remainSlots}} 个名额',
  bookExperience: '预订体验',
  book: '预订',
  apply: '应用',
  maxPartySizes: '每组最多 {{maxGroupSize}} 个名额',
  maxPartySize: '每组最多 {{maxGroupSize}} 个名额',
  selectSessionValidation: '请选择课程',
  selectParticipantValidation: '请选择参与者',
  selectDateValidation: '请选择日期',
  reminders: '提醒',
  seeOtherDates: '查看其他日期',
  location: '位置',
  about: '关于',
  soldOut: '已售罄',
  reviews: '评价',
  reviewSingular: '评价',
  reviewPlural: '评价',
  dateOfExperience: '体验日期',
  readLess: '收起',
  readMore: '展开',
  seeMore: '查看更多',
  details: '详情',
  theFollowingVideoDoesNotContainAnyAudio: '以下视频不包含音频',
  by: '由',
  amenities: '设施',
};
